import React from 'react';
import { globalHistory, Router } from '@reach/router';
import { QueryParamProvider } from 'use-query-params';
import PartnerItemsListingFilter from './PartnerItemsListingFilter';
import { useHabitat } from '@react/shared/HabitatContext';
const PartnerItemsListingFilterRoot = () => {
    const { partnerId } = useHabitat();
    return (React.createElement(QueryParamProvider, { reachHistory: globalHistory },
        React.createElement(Router, { primary: false },
            React.createElement(PartnerItemsListingFilter, { partnerId: partnerId, default: true }))));
};
export default PartnerItemsListingFilterRoot;
